<script lang="ts">
  import Board, { initializeSelection } from '~/board/Board.svelte';
  import GameContext from '~/store/GameContext.svelte';
  import { Tutorial } from '~/store/daily.svelte';
  import { lettersToBoard } from '~/board/utils';
  import DimensionsContext from '~/utils/DimensionsContext.svelte';

  const getBoard = () =>
    lettersToBoard([
      ['', '', '', ''],
      ['', '', '', ''],
      ['', '', '', ''],
      ['', '', '', ''],
    ]);

  let board = getBoard();

  const ex1 = new Tutorial(board);
  const ex2 = new Tutorial(board);
  const ex3 = new Tutorial(board);
  const ex4 = new Tutorial(board);

  const s1 = initializeSelection();
  const s2 = initializeSelection();
  const s3 = initializeSelection();
  const s4 = initializeSelection();

  for (const [i, j] of [
    [2, 1],
    [2, 2],
    [2, 3],
  ]) {
    ex1.highlighted[ex3.board[i][j].id] = 'red';
  }

  for (const [i, j] of [
    [0, 1],
    [1, 1],
    [2, 1],
  ]) {
    ex2.highlighted[ex3.board[i][j].id] = 'red';
  }

  for (const [i, j] of [
    [0, 1],
    [1, 1],
    [2, 1],
    [3, 1],
  ]) {
    ex3.highlighted[ex3.board[i][j].id] = 'green';
  }

  for (const [i, j] of [
    [1, 0],
    [1, 1],
    [1, 2],
    [1, 3],
  ]) {
    ex4.highlighted[ex3.board[i][j].id] = 'green';
  }

  const size = {
    width: 120,
    height: 120,
  };
</script>

<h4>Like this</h4>
<div class="container-container good">
  <div class="board-container">
    <GameContext game={ex3}>
      <DimensionsContext {...size}>
        <Board selected={s3} disabled />
      </DimensionsContext>
    </GameContext>
  </div>
  <div class="board-container">
    <GameContext game={ex4}>
      <DimensionsContext {...size}>
        <Board selected={s4} disabled />
      </DimensionsContext>
    </GameContext>
  </div>
</div>
<h4>Not Like This</h4>
<div class="container-container bad">
  <div class="board-container">
    <GameContext game={ex1}>
      <DimensionsContext {...size}>
        <Board selected={s1} disabled />
      </DimensionsContext>
    </GameContext>
  </div>
  <div class="board-container">
    <GameContext game={ex2}>
      <DimensionsContext {...size}>
        <Board selected={s2} disabled />
      </DimensionsContext>
    </GameContext>
  </div>
</div>

<style lang="scss">
  .container-container {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    justify-items: center;
    width: 100%;
    :global(*) {
      pointer-events: none;
    }
  }
  .board-container {
    & :global(.tile .score) {
      display: none;
    }
  }
</style>
